
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("iskSB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $d6fb09ccb9896306$var$_swiper = $d6fb09ccb9896306$var$_interopRequireDefault((parcelRequire("2mpqL")));

var $5PBbn = parcelRequire("5PBbn");
function $d6fb09ccb9896306$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// ====================================================================================
// swiper1.module
// ====================================================================================
// Pagination, Scrollbar
var $d6fb09ccb9896306$var$init = module.exports.init = function init() {
    var swiperContainers = document.querySelectorAll(".swiper-container--1");
    swiperContainers.forEach(function(slider) {
        var attempts = 0;
        var cID = slider.getAttribute("id");
        var swiper = new $d6fb09ccb9896306$var$_swiper["default"]("#".concat(cID), {
            modules: [
                $5PBbn.Pagination,
                $5PBbn.Keyboard,
                $5PBbn.A11y
            ],
            rewind: true,
            enabled: true,
            speed: 500,
            initialSlide: 0,
            slidesPerView: "auto",
            centeredSlides: true,
            slidesOffsetAfter: 50,
            spaceBetween: 20,
            pagination: {
                el: "#".concat(cID, " .swiper-pagination"),
                clickable: true,
                renderBullet: function renderBullet(index, className) {
                    return '<span class="'.concat(className, ' dot">').concat(index, "</span>");
                }
            },
            keyboard: {
                enabled: true
            },
            a11y: {
                enabled: true
            },
            breakpoints: {
                // when window width is >= 768px
                768: {
                    centeredSlides: false,
                    spaceBetween: 0,
                    enabled: false
                }
            },
            on: {
                afterInit: function afterInit(swiper) {
                    document.querySelector("#".concat(cID)).classList.add("slider-init");
                    swiper.updateSize();
                    swiper.updateSlides();
                },
                beforeSlideChangeStart: function beforeSlideChangeStart(swiper) {
                    var slide = swiper.slides[swiper.activeIndex];
                    var tooltips = slide.querySelectorAll('[data-bs-toggle="tooltip"].open');
                    tooltips.forEach(function(tooltip) {
                        tooltip.click();
                    });
                }
            }
        });
        swiper.updateSize();
        swiper.updateSlides();
        // if document.ready needed
        var _whenComplete = function whenComplete() {
            if (attempts > 30) return;
            attempts += 1;
            if (document.readyState === "complete") {
                swiper.update();
                swiper.updateSize();
                swiper.updateSlides();
                window.addEventListener("resize", function() {
                    if (window.innerWidth > 767) {
                        swiper.slideTo(0, 0);
                        swiper.slideReset(0);
                    }
                });
            } else setTimeout(function() {
                _whenComplete();
            }, 400);
        };
        _whenComplete();
    });
};

});

parcelRegister("jHMUv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e587f90d126edbfb$export$71511d61b312f219; });

var $5gKb4 = parcelRequire("5gKb4");
function $e587f90d126edbfb$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5gKb4._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("5gKb4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3d624443cd99befe$export$71511d61b312f219; });
function $3d624443cd99befe$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hYccX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d15182816097eec3$export$71511d61b312f219; });
function $d15182816097eec3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d15182816097eec3$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d15182816097eec3$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=swiper1.module.051ab5a0.js.map
